// Components
import { CommandButton } from "./CommandButton"

// Third-Party Libraries
import { useNavigate } from "react-router-dom"

export function CancelButton(params: {
  onClick?: () => void
}): JSX.Element {
  // Hooks
  const navigate = useNavigate()

  return (
    <CommandButton
      type="button"
      actiontype="cancel"
      onClick={() => {
        if (params.onClick) {
          params.onClick()
          return
        }

        navigate(-1)
      }}
    />
  )
}